export default __webpack_public_path__ + "static/media/slack-icon.fb1d5170.png";